import SEOMeta from '@/components/feature/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Home() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '农民影视',
    url: 'https://www.nongminyingshi.com',
    description: '农民影视提供免费高清影视在线观看不缓冲服务，涵盖高清电影免费看、电视剧免费全集。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.nongminyingshi.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="农民影视 | 免费高清影视在线观看不缓冲 - 高清电影免费看与电视剧免费全集"
        description="农民影视提供免费高清影视在线观看不缓冲服务，涵盖高清电影免费看、电视剧免费全集，高清流畅播放体验，即点即播无需等待，尽享影视盛宴。"
        keywords="农民影视,免费高清影视,在线观看不缓冲,高清电影免费看,电视剧免费全集,高清流畅播放,免费在线观看,高清电影,电视剧全集"
        canonicalUrl="/"
        ogTitle="农民影视 | 免费高清影视在线观看不缓冲"
        ogDescription="农民影视提供免费高清影视在线观看不缓冲服务，即点即播无需等待，尽享影视盛宴。"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />

      <Navbar />

      <main>
        <HeroSection />

        <FeaturedSection />

        <CategorySection />

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-[1280px] mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                为什么选择农民影视
              </h2>
              <p className="text-sm text-foreground-500 mt-1">五大优势，打造极致观影体验</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
              {[
                { icon: 'ri-shield-check-line', title: '完全免费', desc: '无会员费无隐藏收费' },
                { icon: 'ri-4k-line', title: '高清画质', desc: '支持1080P及4K播放' },
                { icon: 'ri-speed-up-line', title: '流畅不缓冲', desc: '全球CDN加速网络' },
                { icon: 'ri-stack-line', title: '海量资源', desc: '10万+影视内容' },
                { icon: 'ri-device-line', title: '多端支持', desc: '电脑平板手机全兼容' },
              ].map((item) => (
                <div key={item.title} className="flex flex-col items-center text-center p-5 rounded-xl bg-background-50 border border-background-200/60">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <LatestSection />

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-[1280px] mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                探索更多分类
              </h2>
              <p className="text-sm text-foreground-500 mt-1">发现您感兴趣的影视类型</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/30 transition-all"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors">
                    <i className={`${cat.icon} text-lg`}></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-900 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-[1280px] mx-auto text-center">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
              开始您的观影之旅
            </h2>
            <p className="text-sm text-foreground-500 mb-6 max-w-lg mx-auto">
              加入5,800万用户的行列，在农民影视享受免费高清影视在线观看不缓冲的极致体验
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all text-sm whitespace-nowrap"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}